<div class="product-container" (click)="onItemClick()">
  <div class="item-image" [ngClass]="{ 'neutral-background': !productItem.img }" *ngIf="isLandscapeMode">
    <img
      *ngIf="productItem.img"
      [src]="productItem.img"
      [alt]="productItem.name"
    />
    <mnt-icon
      *ngIf="!productItem.img"
      icon="image"
      color="#4B5053"
      [background]="['#E5E7E8', 'rounded']"
      size="large"
    ></mnt-icon>
  </div>

  <div class="product-info">
    <div class="product-header">
      <h3 class="label-medium-medium">
        {{ productItem.name }}
      </h3>

      <p class="label-regular-small product-description" *ngIf="productItem.description">
        {{ productItem.description }}
      </p>
    </div>

    <div class="price-container">
      @if(productItem.promotional_price) {
        <span class="current-price">
          @if(hasMinValue) {
            <span>A partir de {{ displayPrice | currency }}</span>
          } @else {
            {{ displayPrice | currency }}
          }
        </span>

        <span class="original-price">
          @if(hasMinValue) {
            <span>{{ originalDisplayPrice | currency }}</span>
          } @else {
            {{ originalDisplayPrice | currency }}
          }
        </span>

        <mnt-badge
          *ngIf="productItem.promotional_percentage"
          [label]="productItem.promotional_percentage + '%'"
          color="primary"
          variant="regular"
          size="tiny"
          tone="highlight"
        ></mnt-badge>
      } @else {
        <span class="current-price">
          @if(hasMinValue) {
            <span>A partir de {{ displayPrice | currency }}</span>
          } @else {
            {{ displayPrice | currency }}
          }
        </span>
      }
    </div>
  </div>
  <div class="item-image" *ngIf="!isLandscapeMode" [ngClass]="{ 'neutral-background': !productItem.img }">
    <img
      *ngIf="productItem.img"
      [src]="productItem.img"
      [alt]="productItem.name"
    />
    <mnt-icon
      *ngIf="!productItem.img"
      icon="image"
      color="#4B5053"
      [background]="['#E5E7E8', 'rounded']"
      size="large"
    ></mnt-icon>
  </div>
</div>
